var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "sw-grid-flex sw-grid-flex--align-center sw-grid-flex--wrap--tab"
      },
      [
        _c(
          "form",
          {
            staticClass:
              "sw-model-material-drag-and-drop-upload__content sw-grid-flex__cell",
            attrs: {
              "data-sw-model-material-drag-and-drop-upload-form": "",
              method: "post",
              action: _vm.uploadAction + "?appId=" + _vm.appId,
              enctype: "multipart/form-data"
            }
          },
          [
            _c("input", {
              attrs: { type: "hidden", name: "appId" },
              domProps: { value: _vm.appId }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "sw-dms--color-grey-46 sw--cursor-pointer",
                attrs: { for: "up3Dfile" }
              },
              [
                _c(
                  "div",
                  {
                    attrs: {
                      "data-sw-model-material-drag-and-drop-upload-area": ""
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sw-grid-flex\n              sw-grid-flex--align-center\n              sw--padding-vert-4\n              sw--padding-hor-3\n              sw-dms--bg-grey-96\n              sw--border-grey-1\n              sw--border-radius-3\n              sw--border-style-dashed\n              sw-dms--color-grey-46"
                      },
                      [
                        _c("div", {
                          staticClass:
                            "icon-upload sw--font-size-28 sw--margin-right-3"
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sw--display-none sw--display-block--tab sw--text-underline"
                            },
                            [_vm._v("Upload a 3D file")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "sw--display-none--tab" }, [
                            _vm._v("Choose a 3D file")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "sw--display-none",
                            attrs: {
                              "data-sw-model-material-drag-and-drop-upload-file-input":
                                "",
                              type: "file",
                              id: "up3Dfile",
                              name: "file",
                              accept: _vm.acceptedModelExtensions,
                              "data-sw-max-file-size": _vm.maxUploadSize
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "sw--display-none--tab" }, [
                            _vm._v(" or drag it here")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "sw-grid-flex sw-grid-flex--align-center sw--margin-left-auto sw-dms--color-grey-46",
                            attrs: { for: "drop-zone-scale" }
                          },
                          [
                            _c("span", { staticClass: "sw--font-size-12" }, [
                              _vm._v("UNITS: ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sw-dropdown--plain sw-dropdown__container sw--border-none"
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "sw-dropdown__select sw-dms--color-grey-46",
                                    attrs: {
                                      "data-sw-dropdown": "",
                                      "data-sw-dropdown-vendor": "selectric",
                                      id: "drop-zone-scale",
                                      name: "scale"
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        attrs: { selected: "" },
                                        domProps: {
                                          value: _vm.scaleMillimeters
                                        }
                                      },
                                      [_vm._v("MM")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { domProps: { value: _vm.scaleMeters } },
                                      [_vm._v("M")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { domProps: { value: _vm.scaleInches } },
                                      [_vm._v("IN")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        ),
        _vm._v(" "),
        _vm.showDesignWithShapeways
          ? _c(
              "div",
              {
                staticClass:
                  "sw--margin-left-2 sw--margin-left-0--tab sw--margin-vert-2--tab"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sw--margin-left-2 sw--margin-right-2 sw--display-inline"
                  },
                  [_vm._v("\n        or\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "sw-dms-button sw-dms-button--red sw-dms-button--small sw-dms--box-shadow",
                    attrs: { href: _vm.designWithShapewaysUrl }
                  },
                  [_vm._v("\n        Don't have a 3d File?\n      ")]
                )
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "sw-model-material-drag-and-drop-upload__content sw--is-hidden",
        attrs: { "data-sw-model-material-drag-and-drop-upload-file-error": "" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell\n        sw-grid-flex\n        sw-grid-flex--align-center\n        sw--padding-4\n        sw--bg-alert-red-lightest\n        sw--border-radius-3\n        sw--position-relative\n        sw--margin-top-2"
          },
          [
            _c("div", {
              staticClass:
                "icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sw--is-hidden",
                attrs: {
                  "data-sw-model-material-drag-and-drop-upload-file-count-error":
                    ""
                }
              },
              [
                _vm._v(
                  "\n        Wait up! Our systems can only handle one file at a time! Please try uploading again with a single file.\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sw--is-hidden",
                attrs: {
                  "data-sw-model-material-drag-and-drop-upload-file-format-error":
                    ""
                }
              },
              [
                _vm._v(
                  "\n        Oh no! We don’t support this file format. Check out our\n        "
                ),
                _c(
                  "a",
                  {
                    staticClass: "sw--margin-left-auto",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openSupportedFileTypes($event)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "sw--text-decoration-underline sw-dms--text-dark"
                      },
                      [_vm._v("Supported file types")]
                    )
                  ]
                ),
                _vm._v(".\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sw--is-hidden",
                attrs: {
                  "data-sw-model-material-drag-and-drop-upload-file-size-error":
                    ""
                }
              },
              [
                _vm._v(
                  "\n        Oh no! Your file size is too big for us to process. Please try again with another file.\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sw--is-hidden",
                attrs: {
                  "data-sw-model-material-drag-and-drop-upload-generic-error":
                    ""
                }
              },
              [
                _vm._v(
                  "\n        Oh no! Something went wrong and we couldn’t process your file. Please try again in a few minutes!\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "sw--is-hidden",
              attrs: { "data-sw-model-material-drag-and-drop-upload-error": "" }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "sw-model-material-drag-and-drop-upload__content-error-spacer"
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sw--font-size-12" }, [
      _vm._v(
        "New model volume should not be more than 10% than the original model volume."
      )
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.openSupportedFileTypes($event)
          }
        }
      },
      [
        _c(
          "span",
          {
            staticClass:
              "sw--font-size-12 sw--text-decoration-underline sw-dms--text-light"
          },
          [_vm._v("Supported file types")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "sw-model-material-drag-and-drop-upload__content\n          sw-model-material-drag-and-drop-upload__uploading\n          sw--is-hidden\n          sw-grid-flex\n          sw-grid-flex--align-center\n          sw--position-relative\n          sw-grid-flex\n          sw-grid-flex--align-center\n          sw--padding-hor-4\n          sw-dms--bg-grey-96\n          sw--border-transparent-1\n          sw--border-radius-3\n          sw--margin-bottom-1",
        attrs: { "data-sw-model-material-drag-and-drop-upload-uploading": "" }
      },
      [
        _c("div", { staticClass: "sw-dms--color-grey-46 sw--margin-left-2" }, [
          _vm._v("Uploading Your Model")
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "sw-model-material-drag-and-drop-upload__progress-bar\n            sw-dms--bg-purple\n            sw--position-absolute\n            sw--position-left\n            sw--position-bottom\n            sw--border-radius-2",
          attrs: {
            "data-sw-model-material-drag-and-drop-upload-progress-bar": ""
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }